import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "bg-gray-900 min-h-screen py-24 sm:py-32",
  id: "Pricing"
}
const _hoisted_2 = { class: "mx-auto max-w-7xl px-6 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto text-4xl text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", {
    class: "text-base font-semibold leading-7 text-6xl text-indigo-400",
    style: {"font-size":"4rem !important"}
  }, "Pricing")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-300" }, " Discover our affordable detailing packages, tailored to rejuvenate your vehicle's interior. Experience meticulous attention to detail, ensuring a pristine and luxurious finish every time. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-16 flex justify-center" }, null, -1)
const _hoisted_6 = { class: "isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-3" }
const _hoisted_7 = { class: "flex items-center justify-between gap-x-4" }
const _hoisted_8 = ["id"]
const _hoisted_9 = {
  key: 0,
  class: "rounded-full bg-indigo-500 px-2.5 py-1 text-xs font-semibold leading-5 text-white"
}
const _hoisted_10 = {
  class: "mt-4 text-sm leading-6 pt-6 text-indigo-500 text-center",
  style: {"font-size":"4rem !important"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mt-6 flex items-baseline gap-x-1" }, null, -1)
const _hoisted_12 = {
  role: "list",
  class: "mt-8 space-y-3 text-sm leading-6 text-gray-300 xl:mt-10"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", {
  class: "text-lg",
  style: {"font-size":"1.5rem !important"}
}, "Cleaning of all interior surfaces ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckIcon = _resolveComponent("CheckIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiers, (tier) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tier.id,
            class: _normalizeClass([tier.mostPopular ? 'bg-white/5 ring-2 ring-indigo-500' : 'ring-1 ring-white/10', 'rounded-3xl p-8 xl:p-10'])
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h3", {
                id: tier.id,
                class: "text-lg font-semibold leading-8 text-3xl text-indigo-300"
              }, _toDisplayString(tier.name), 9, _hoisted_8),
              (tier.mostPopular)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Most popular"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(tier.description), 1),
            _hoisted_11,
            _createElementVNode("ul", _hoisted_12, [
              _hoisted_13,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tier.features, (feature) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: feature,
                  class: "flex gap-x-3"
                }, [
                  _createVNode(_component_CheckIcon, {
                    class: "h-6 w-5 flex-none text-white",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" " + _toDisplayString(feature), 1)
                ]))
              }), 128))
            ])
          ], 2))
        }), 128))
      ])
    ])
  ]))
}